import React from "react";
import Checkbox from "../Checkbox";
import toDisplayCase from "../toDisplayCase";

function Head({fields, selectable, columns, excludes, actionsList, selected, onSelectAll, objects}) {
    return (
        <tr>
            {selectable && (
                <th>
                    <Checkbox
                        className="align-middle"
                        id="check_all"
                        checked={objects.length === selected.length && objects.length !== 0}
                        onChange={checked => onSelectAll(checked)}
                    />
                </th>
            )}
            {
                columns.map((field) => {
                    const {type, ...options} = fields[field];
                    if (excludes.includes(field)) return null;
                    const label = options.label || toDisplayCase(field);
                    return (
                        <th key={field}
                            className="fs-xs align-middle text-nowrap">{label}</th>
                    );
                })}
            {actionsList.length > 0 && (
                <>
                    <th>
                        <div style={{width: "50px"}}></div>
                    </th>
                    <th
                        className="fs-xs align-middle text-nowrap"
                        colSpan={actionsList.length}>ACTIONS
                    </th>
                </>
            )}
        </tr>
    )
}

export default Head;